import {RequestBody} from '../../entity/core/request-body';
import SearchStore from '../store/search-store';
import {SearchDto} from '../../entity/dto/search-dto';
import {SearchResponse} from '../../entity/resource/search-response';
import {SearchInputDto} from '../../entity/dto/search-input-dto';
import {BusinessRecordSearchDto} from '../../entity/dto/business-record-search-dto';
import {CompanyType} from '../../entity/enums/company-type';

export default class SearchService {
  searchStore: SearchStore;

  constructor(searchStore: SearchStore) {
    this.searchStore = searchStore;
  }

  searchEntity = async (organizationId: string, searchDto: SearchDto): Promise<SearchResponse | undefined> => {
    const requestBody: RequestBody = { body: searchDto };
    const response = await this.searchStore.searchEntity(organizationId, requestBody);

    if (typeof response !== 'string')
      return response;
  }

  getSearchInputDto = () : SearchInputDto => {
    return {
      searchInput: ''
    };
  }

  getDefaultBusinessRecordSearchValues = (): BusinessRecordSearchDto => {
    return {
      searchInput: '',
      companyType: CompanyType.ALL,
      state: '',
      county: ''
    };
  }
}